"use client";

import Link from "next/link";

import type { HeaderBellVariant } from "./types";

import NotificationBellFramerComponent from "@/framer/header-navbar/notification-bell";

export interface HeaderNotificationBellProps {
	variant?: HeaderBellVariant;
	href?: string;
	ariaLabel?: string;
}

export function HeaderNotificationBell({
	variant = "Variant 1",
	href = "/notifications",
	ariaLabel = "Notifications",
}: HeaderNotificationBellProps) {
	return (
		<Link href={href} className="contents" aria-label={ariaLabel}>
			<NotificationBellFramerComponent.Responsive variants={{ base: variant }} />
		</Link>
	);
}
